import styled from 'styled-components'

import { MEDIA_QUERIES } from "@constants"

import AnchorLink from '@components/AnchorLink/AnchorLink'

export const IntegrationsFeaturedAppsDIV = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: stretch;
  margin-bottom: var(--spacing--L);

  ${MEDIA_QUERIES.L} {
    justify-content: space-between;
  }
`

export const IntegrationsFeaturedAppsCardLINK = styled(AnchorLink)`
  align-items: center;
  background: var(--color--basics-white);
  border-radius: 6px;
  bottom: 0;
  box-shadow: var(--elevation--S);
  display: flex;
  flex-direction: column;
  flex: 0 0 100%;
  gap: var(--spacing--XS);
  justify-content: center;
  margin-bottom: 30px;
  overflow: hidden;
  padding: var(--spacing--base-1-25) var(--spacing--base-1-25) calc(var(--spacing--base-1-75) + 60px);
  position: relative;
  transition: all 0.25s;
  z-index: 1;

  p {
    margin: 0;
    color: var(--color--text-default);
    text-wrap: balance;
  }

  p,
  .learn-more {
    text-align: center;
  }

  .learn-more {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 60px;
    line-height: 56px;
    font-weight: 500;
    border-top: 1px solid var(--color--charcoal-200);
    transition: background-color 0.3s;
  }

  .Badge {
    position: absolute;
    top: 20px;
    right: 20px;
  }

  & a {
    display: flex;
  }

  &:hover {
    bottom: 8px;
    box-shadow: var(--elevation--L);

    .learn-more {
      background: var(--color--charcoal-100);
    }
  }

  ${MEDIA_QUERIES.M} {
    flex: 0 0 60%;
  }
  
  ${MEDIA_QUERIES.L} {
    margin-bottom: 0;

    .item-count--1 & {
      flex: 0 0 100%;
    }

    .item-count--2 & {
      flex: 0 0 calc(50% - var(--spacing--XS) / 2);
    }

    .item-count--3 & {
      flex: 0 0 calc(33% - var(--spacing--XS) * 2 / 3);
    }

    .item-count--4 & {
      flex: 0 0 calc(25% - var(--spacing--XS) * 3 / 4);
    }
  }
`
